import { useEffect } from "react";
import "./NationXPopup.css";

const NationXPopup = ({ onClose }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  return (
    <div className="nx-overlay">
      <div className="nx-popup">
        <h2>🚀 NationX Upcoming Products</h2>

        <p className="nx-subtitle">
          Premium Mobile Accessories launching soon
        </p>

        <ul className="nx-list">
          <li>🔋 Fast Charge Power Bank</li>
          <li>🎧 Wireless Earbuds Pro</li>
          <li>📱 Shockproof Mobile Covers</li>
          <li>🔌 Type-C & Lightning Cables</li>
          <li>🚗 Car Mobile Chargers</li>
        </ul>

        <p className="nx-note">
          You are being redirected to the official NationX website.
        </p>

        <button className="nx-btn" onClick={onClose}>
          Continue to Website
        </button>
      </div>
    </div>
  );
};

export default NationXPopup;
